import React from 'react'
import Flex from 'typescript-styled-flex'
import styled from '../../../../../theme'
import { shadowStyles } from '../../Button/FilterButton'

const Header = styled(({ ...rest }) => <Flex as={'header'} {...rest} />)`
  ${shadowStyles};

  position: sticky;
  z-index: 200;
`

export default Header
